// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/calendar-clock.js';

import { paths } from '../generated/calendar-clock';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('calendar-clock', Original, paths);
